import script from "./NewTicketPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./NewTicketPanel.vue?vue&type=script&setup=true&lang=js"

import "./NewTicketPanel.vue?vue&type=style&index=0&id=5e96e663&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e96e663"]])

export default __exports__